'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usageTrackerPropType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.Trackable = Trackable;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getComponentName = require('react-utils/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _utils = require('./utils');

var _hoistNonReactStatics = require('../vendor/hoistNonReactStatics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usageTrackerPropType = exports.usageTrackerPropType = _react.PropTypes.shape({
  track: _react.PropTypes.func.isRequired,
  clone: _react.PropTypes.func,
  setProperties: _react.PropTypes.func
});

var contextTypes = {
  usageTracker: usageTrackerPropType
};

function Trackable(WrappedComponent) {
  var TrackedComponent = (0, _react.createClass)({
    displayName: 'Trackable(' + (0, _getComponentName2.default)(WrappedComponent) + ')',

    propTypes: _extends({}, contextTypes),

    contextTypes: _extends({}, contextTypes),

    getUsageTracker: function getUsageTracker() {
      return this.props.usageTracker || this.context.usageTracker;
    },
    render: function render() {
      var _this = this;

      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
        ref: function ref(wrappedInstance) {
          (0, _utils.copyMethods)(wrappedInstance, _this);
        },
        usageTracker: this.getUsageTracker()
      }));
    }
  });

  TrackedComponent = (0, _hoistNonReactStatics2.default)(TrackedComponent, WrappedComponent);
  // need to attach this last to make sure they're not overwritten by hoistNonReactStatics
  (0, _utils.attachWrappedComponent)(TrackedComponent, WrappedComponent);
  return TrackedComponent;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/decorators/Trackable.js
// module id = 270
// module chunks = 0